function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIosAddToHomescreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717079"
    },
    d: "M18.8,23.2H5.2c-1.4,0-2.6-1.2-2.6-2.6V6.9c0-1.4,1.2-2.6,2.6-2.6h13.7c1.4,0,2.6,1.2,2.6,2.6v13.7 C21.4,22,20.3,23.2,18.8,23.2z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 12,
    y1: 10.1,
    x2: 12,
    y2: 17.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.3487,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 12,
    y1: 10.1,
    x2: 12,
    y2: 17.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.3487,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 15.7,
    y1: 13.8,
    x2: 8.3,
    y2: 13.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosAddToHomescreenIcon);
export default __webpack_public_path__ + "static/media/ios-add-to-homescreen-icon.86dae272.svg";
export { ForwardRef as ReactComponent };